import * as React from 'react';

interface RenderLeafletMapProps {
  shippingPoints: any[];
  gpsCoordinates: any;
  onPrClick(shippingPoint: any): void;
}

/**
 *
 * CE COMPONENT NE FONCTIONNE PAS ENCORE
 *
 */
export class LeafletMap extends React.Component<RenderLeafletMapProps, Record<string, unknown>> {

  private readonly id: any;
  private ref: any;

  constructor(props: RenderLeafletMapProps) {
    super(props);

    this.ref = null;

    this.state = {};
  }

  _onMarkerClick = (e: any) => {
    if (this.props.onPrClick) {
      this.props.onPrClick(e.detail.marker.marker.additionnalInfo);
    }
  }

  componentWillUnmount() {
    this._removeListeners();
  }

  _removeListeners() {
    if (this.ref) {
      this.ref.removeEventListener('map-marker-click', this._onMarkerClick);
    }
  }

  _renderMap() {
    this._removeListeners();

    return React.createElement('dp-cart-shipping-points-maps-display', {
      ref: (ref: any) => {
        if (!ref) return;
        ref.shippingPoints = this.props.shippingPoints;
        ref.gpsCoordinates = this.props.gpsCoordinates;

        ref.addEventListener('map-marker-click', this._onMarkerClick);

        this.ref = ref;
      },
    });
  }

  render() {
    return (
      <div>
        <link rel="import" href="/order/bower_components/polymer/polymer.html"/>
        <link rel="import" href="/order/src/dp-cart/shipping-point/dp-cart-shipping-points-maps-display.html"/>

        {this._renderMap()}
      </div>
    );
  }
}
